import { type StateCreator } from 'zustand';

import { type UseTrackCanvasCreatedParams } from '@air/analytics';
import { type AppNode } from '@air/feature-edit-canvas';

export type DraftCanvasAnalyticsContext = {
  source: UseTrackCanvasCreatedParams['source'];
  board_id?: string;
  library_id?: string;
};

export type DraftCanvasState = {
  boardId?: string;
  analyticsContext: DraftCanvasAnalyticsContext;
  /** Pre-built nodes to add when the canvas editor mounts */
  initialNodes?: AppNode[];
  /** Toast message to show after initial nodes are added */
  insertionToastMessage?: string | null;
};

export type DraftCanvasSlice = {
  draftCanvas: DraftCanvasState | null;
  /** Transient flag set during draft→real transition to prevent store clearing */
  committingDraft: boolean;
  setDraftCanvas: (draft: DraftCanvasState | null) => void;
  setCommittingDraft: (committing: boolean) => void;
};

export type CreateDraftCanvasSlice = () => StateCreator<DraftCanvasSlice, [], [], DraftCanvasSlice>;

export const createDraftCanvasSlice: CreateDraftCanvasSlice = () => (set) => ({
  draftCanvas: null,
  committingDraft: false,
  setDraftCanvas: (draft: DraftCanvasState | null) => {
    set({ draftCanvas: draft });
  },
  setCommittingDraft: (committing: boolean) => {
    set({ committingDraft: committing });
  },
});
